module.exports = __webpack_public_path__ + "img/image5.bbb19ca4.png";